import { AppState } from '~system/store/configure-store';

export const selectActiveScope = (state: AppState) => state.scope.scope;
